import { tns } from 'tiny-slider';

(function($) {
    // Commented these out because we are now using the $logoCarousel on CourseEntry pages
    // const $dealsPageNew = $('.DealsPage-new');
    // if (!$dealsPageNew.length) return;

    // https://github.com/ganlanyuan/tiny-slider
    const $logoCarousel = $('#logo-carousel');
    if ($logoCarousel.length) {
        const slider = tns({
            container: '#logo-carousel',
            loop: true,
            items: 1,
            slideBy: 1,
            autoplay: true,
            autoplayButtonOutput: false,
            autoWidth: true,
            controls: false,
            nav: false,
            center: true,
            // speed: 1,
            autoplayTimeout: 1000,
            gutter: 20,
            edgePadding: 50,
            center: true,
            responsive: {
                576: {
                    items: 3,
                    edgePadding: 50,
                    gutter: 40,
                    center: false,
                },
                768: {
                    edgePadding: 100,
                    center: false,
                }
            }
        });
        const $logoCarouselWrapper = $('.logo-carousel-wrapper');
        if ($logoCarouselWrapper.length) {
            $logoCarouselWrapper.show();
        }
    }

    const $dlpLogoCarousel = $('#dlp-logo-carousel');
    if ($dlpLogoCarousel.length) {
        const slider = tns({
            container: '#dlp-logo-carousel',
            loop: true,
            items: 1,
            slideBy: 1,
            autoplay: true,
            autoplayButtonOutput: false,
            autoWidth: true,
            controls: false,
            nav: false,
            center: true,
            // speed: 1,
            autoplayTimeout: 1000,
            gutter: 20,
            edgePadding: 50,
            center: true,
            // responsive: {
            //     576: {
            //         items: 3,
            //         edgePadding: 50,
            //         gutter: 40,
            //         center: false,
            //     },
            //     768: {
            //         edgePadding: 100,
            //         center: false,
            //     }
            // }
        });
    }
})(jQuery);



// WEBPACK FOOTER //
// ./js/modules/dealsPage.js